module.exports = __webpack_public_path__ + "static/media/2.2ee4a81c.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/hairfront/2.png
// module id = 697
// module chunks = 0